module.exports = __webpack_public_path__ + "assets/img/btn-view-bf867c72.png";